<template>
  <grid-container class="text-center">
    <p>Ați finalizat cu succes acest test.</p>

    <p>Pentru a continua cu următorul test, vă rugăm să faceți clic pe butonul de mai jos</p>

    <el-button @click="returnToTest" type="primary">
      Continua
    </el-button>
  </grid-container>
</template>

<script>
export default {
  name: 'Completed',
  computed: {
    siteUrl() {
      return process.env.VUE_APP_DASHBOARD_SJT_SCREEN
    },
    softSkillsInvited() {
      return this.$store.getters.softSkillsInvited
    },
    finishedTest() {
      const finished = this.softSkills.filter(skill => {
        return skill.status === 'FINISHED'
      })

      return finished[0]
    },
    testName() {
      const currentSkill = this.finishedTest

      if (currentSkill.name === 'RESILIENCE') {
        return 'Electricians Test'
      }

      if (currentSkill.name === 'ADAPTABILITY') {
        return 'Operator Test'
      }

      if (currentSkill.name === 'DECISION_MAKING') {
        return 'Technicians Test'
      }

      return 'General Test'
    },
    softSkills() {
      return this.$store.getters.softSkills
    }
  },
  methods: {
    returnToTest() {
      window.location.href = 'https://pmiromaniatest.owiwi.co.uk/sjt'
      // window.location.href = 'http://localhost:8082/sjt'
      // this.$router.replace('/sjt')
    }
  }
}
</script>

<style scoped>
  .container p {
    margin: 24px 0;
  }
</style>
